import moment from "moment";
export const getCurrentDateTime = () => {
    return moment().local().format(moment.DATETIME_LOCAL_SECONDS)
};